import React from "react";
import { TextField } from "@mui/material";

export default function MuiInput({
  label = "",
  value = "",
  onChange,
  placeholder = "",
  required = false,
  disabled = false,
  readOnly = false,
  error = false,
  helperText = "",
  fullWidth = true,
  size = "small",
  variant = "outlined",
  type = "text",
  id,
  name,
  className = "",
  sx = {},
  ...rest
}) {
  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  return (
    <TextField
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      size={size}
      variant={variant}
      type={type}
      InputProps={{
        readOnly,
      }}
      slotProps={{
        inputLabel: {
          sx: {
            color: "#C5C1BFFF",
            "&.Mui-focused": {
              color: "black",
            },
            "& .MuiFormLabel-asterisk": {
              color: "red",
            },
          },
        },
        htmlInput: {
          style: {
            color: "black",
          },
        },
      }}
      className={className}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#C5C1BFFF",
            borderWidth: "1px",
          },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#C5C1BFFF",
        },
        ...sx,
      }}
      {...rest}
    />
  );
}
